import {
  IAugmentedJQuery,
  IComponentOptions,
  IController,
  INgModelController
} from 'angular';
import * as moment from 'moment';
import { Moment } from 'moment';
import { $Event } from '../../../helpers';
import './gmc-date-picker.component.scss';
import { cloneDeep } from 'lodash-es';

export class GmcDatePickerController implements IController {
  static $inject = [];
  ngModel: INgModelController;
  onChange: ($event) => void;
  placeholder = 'dd.mm.yyyy';
  minDate: Moment;
  maxDate: Moment;
  startDate: Moment;
  name: string;
  validate = false;
  inputElement: IAugmentedJQuery;
  datepicker;
  datePickerClone: Moment;
  disabled: boolean;
  warn: boolean = false;
  check: boolean;

  constructor() {}

  $onInit() {
    this.ngModel.$render = () => {
      this.datepicker = this.ngModel.$viewValue ? moment(this.ngModel.$viewValue) : undefined;
      this.datePickerClone = cloneDeep(this.datepicker);
    };
  }

  checkDate(date) {
    if (this.check) {
      this.warn = moment(date).isBefore(moment().add(10, 'd'));
      console.log(this.warn);
    }
    return;
  }

  datePicked() {
    if (
      this.maxDate &&
      moment(this.datepicker, 'DD.MM.YYYY').isAfter(this.maxDate)
    ) {
      return (this.datepicker = this.datePickerClone);
    } else if (
      this.minDate &&
      moment(this.datepicker, 'DD.MM.YYYY').isBefore(this.minDate)
    ) {
      return (this.datepicker = this.datePickerClone);
    }
  }

  onDateChanged(newVal: Moment, oldVal: Moment) {
    this.checkDate(newVal);
    console.log('changes');
    const formattedNewVal = this.formatDate(newVal);
    const formattedModelVal = this.formatDate(this.ngModel.$viewValue);
    if (formattedNewVal !== formattedModelVal) {
      this.ngModel.$setViewValue(newVal);
      this.onChange(new $Event({ newVal, oldVal }));
    }
  }

  private formatDate(date: any): string {
    return moment(date).format('DD.MM.YYYY');
  }
}

export const GmcDatePickerComponent: IComponentOptions = {
  controller: GmcDatePickerController,
  template: require('./gmc-date-picker.component.html'),
  require: {
    ngModel: 'ngModel'
  },
  bindings: {
    placeholder: '@?',
    disabled: '<?',
    onChange: '&',
    name: '@?',
    format: '@?',
    minDate: '<',
    maxDate: '<',
    startDate: '<',
    validate: '<?',
    check: '<?'
  }
};



// WEBPACK FOOTER //
// ./app/shared/components/gmc-date-picker/gmc-date-picker.component.ts